import AddIcon from "@mui/icons-material/Add";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyIcon from "@mui/icons-material/Key";
import { IconButton, Switch } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { PsNoData } from "../../../components";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import ModuleAccess from "../../../context/moduleAccess";
import { _UPDATE_MODULE } from "../../../models/modulesModel";

import {
  _DELETE_USER_LOGIN,
  _LIST_USER_LOGINS,
  _UPDATE_LOGIN_STATUS,
} from "../../../models/userLoginModel";
import AddUserLoginForm from "./addUserLoginForm";
import EditUserLoginForm from "./editUserLoginForm";
import EditUserPassword from "./editUserPassword";

const UserLogins = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [agentId, setAgentId] = useState(null);
  const { openDialog } = useDialog();

  useEffect(() => {
    if (context.userData) {
      setAgentId(props.agencyId || context.userData.agent_id);
      loadData(props.agencyId || context.userData.agent_id);
    }
  }, [context.userData]);

  const loadData = (agent_id = false) => {
    if (!context.userData.role) {
      return;
    }
    setLoader(true);

    let rv = {};

    rv.agent_id = agent_id || agentId;

    _LIST_USER_LOGINS(rv).then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
        setDataView(res.data);
      } else {
        setDataList([]);
        setDataView([]);
      }
      setLoader(false);
    });
  };
  const handleDeleteClick = (item) => {
    openDialog({
      title: "Confirm",
      message: `Do you want to delete the user -  ${item.emp_name} ?`,
      onConfirm: () => confirmDelete(item),
    });
  };

  const confirmDelete = (item) => {
    setLoader(true);
    _DELETE_USER_LOGIN({ id: item.id }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Deleted");
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Delete",
        });
        setLoader(false);
      }
    });
  };

  const handleStatusChange = (item, sta) => {
    openDialog({
      title: "Confirm",
      message: "Do you want to change Status ?",
      onConfirm: () => confirmStatusUpdate(item, sta),
    });
  };

  const confirmStatusUpdate = (item, sta) => {
    setLoader(true);
    _UPDATE_LOGIN_STATUS({
      user_id: item.user_id,
      active_status: sta == "1" ? "0" : "1",
    }).then((res) => {
      if (res.status == "1") {
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
        setLoader(false);
      }
    });
  };

  const handleEditClick = (item) => {
    setViewData(item);
    setEditModal(true);
  };

  const handleUpdatePasswordClick = (item) => {
    setViewData(item);
    setEditPassword(true);
  };

  return (
    <>
      <div className={"user-logins-container"}>
        <Card>
          <Card.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                backgroundColor: "#f5f5f5", // Light gray background
                padding: "10px 15px",
                borderRadius: "5px",
                marginBottom: "10px",
              }}
            >
              <ModuleAccess module="user_logins" action="action_create">
                <IconButton
                  color="primary"
                  onClick={() => setAddModal(true)}
                  title="Add Module"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#1976d2",
                    color: "#fff",
                  }}
                >
                  <AddIcon />
                </IconButton>
              </ModuleAccess>
              <IconButton
                color="secondary"
                onClick={() => loadData()}
                title="Refresh"
                style={{ backgroundColor: "#388e3c", color: "#fff" }}
              >
                <AutorenewIcon />
              </IconButton>
            </div>

            <div className={`container`}>
              <Spin spinning={loader}>
                <div>
                  <Table size="sm" hover>
                    <thead>
                      <tr className="fs-12">
                        <th width="60" className="text-center">
                          S.Nos
                        </th>
                        <th>Name</th>
                        <th width="120">Mobile</th>
                        <th>Partner</th>
                        <th width="160">Username</th>
                        <th width="160">Role</th>
                        <th width="80" className="text-center">
                          Status
                        </th>
                        <th width="120" className="text-center">
                          #
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataView.map((item, i) => {
                        return (
                          <tr key={i} className="fs-12 valign-middle">
                            <td align="center">{i + 1}</td>
                            <td className="fw-bold">{item.emp_name}</td>
                            <td>{item.mobile}</td>
                            <td>{item.company_name}</td>
                            <td>{item.username}</td>
                            <td>{item.role_name}</td>
                            <td align="center">
                              <Switch
                                size="small"
                                checked={
                                  item.login_active_status == "1" ? true : false
                                }
                                onChange={(e) =>
                                  handleStatusChange(
                                    item,
                                    item.login_active_status
                                  )
                                }
                              />
                            </td>
                            <td align="center">
                              <ModuleAccess
                                module="update_user_login"
                                action="action_update"
                              >
                                <IconButton
                                  title="Password"
                                  onClick={(e) =>
                                    handleUpdatePasswordClick(item)
                                  }
                                >
                                  <KeyIcon fontSize="small" />
                                </IconButton>
                              </ModuleAccess>
                              <ModuleAccess
                                module="user_logins"
                                action="action_update"
                              >
                                <IconButton
                                  title="Edit"
                                  onClick={(e) => handleEditClick(item)}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </ModuleAccess>
                              <ModuleAccess
                                module="user_logins"
                                action="action_delete"
                              >
                                <IconButton
                                  title="Delete"
                                  onClick={(e) => handleDeleteClick(item)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </ModuleAccess>
                            </td>
                          </tr>
                        );
                      })}
                      {dataList.length < 1 && !loader && (
                        <tr>
                          <td colSpan={8}>
                            <PsNoData withHeight />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Spin>
            </div>
          </Card.Body>
        </Card>
      </div>

      <AddUserLoginForm
        show={addModal}
        agencyId={agentId}
        onHide={(e) => setAddModal(false)}
        onSuccess={() => {
          setAddModal(false);
          loadData();
        }}
      />

      <EditUserLoginForm
        show={editModal}
        dataSource={viewData}
        agencyId={agentId}
        onHide={(e) => {
          setEditModal(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setEditModal(false);
          setViewData([]);
          loadData();
        }}
      />

      <EditUserPassword
        show={editPassword}
        dataSource={viewData}
        onHide={(e) => {
          setEditPassword(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setEditPassword(false);
          setViewData([]);
          loadData();
        }}
      />
    </>
  );
};
export default UserLogins;
